document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const banner = document.querySelector(
      '#shopify-section-sections--25591452631421__newsletter-popup .banner--success'
    );
    if (!banner) return;
    const code = 'HYDRATEFIRST10';
    if (!banner.textContent.includes(code)) return;
    banner.innerHTML = banner.innerHTML.replace(
      code,
      `<span id="discount-code" style="
        cursor: pointer;
        transition: all 0.2s ease;
        position: relative;
        display: inline-block;
      ">${code}</span>`
    );
    const codeEl = document.getElementById('discount-code');

    codeEl.addEventListener('click', () => {
      navigator.clipboard.writeText(code);
      const original = codeEl.textContent;
      codeEl.textContent = 'HYDRATEFIRST10';
      const tooltip = document.createElement('div');
      tooltip.textContent = 'Copied!';
      tooltip.style.position = 'absolute';
      tooltip.style.bottom = '120%';
      tooltip.style.left = '50%';
      tooltip.style.transform = 'translateX(-50%)';
      tooltip.style.background = '#000';
      tooltip.style.color = '#fff';
      tooltip.style.padding = '4px 8px';
      tooltip.style.borderRadius = '4px';
      tooltip.style.fontSize = '12px';
      tooltip.style.whiteSpace = 'nowrap';
      tooltip.style.opacity = '0';
      tooltip.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
      codeEl.appendChild(tooltip);

      requestAnimationFrame(() => {
        tooltip.style.opacity = '1';
        tooltip.style.transform = 'translateX(-50%) translateY(-2px)';
      });

      setTimeout(() => {
        tooltip.style.opacity = '0';
        tooltip.style.transform = 'translateX(-50%) translateY(0)';
        setTimeout(() => tooltip.remove(), 300);
      }, 1200);

      setTimeout(() => {
        codeEl.textContent = original;
      }, 1500);
    });
  }, 500);
});
